import {
  CLEAR_RESEND_SUCCESS,
  RESET,
  SET_EDITED_MEMBER_DATA,
  SET_ERROR,
  SET_IS_PRODUCTIVITY_OVERWRITTEN_SUCCESS,
  SET_MEMBER,
} from './MemberConstants'

export function resetMemberState() {
  return {
    type: RESET,
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function setIsProductivityOverwrittenSuccess(newStatus) {
  return {
    type: SET_IS_PRODUCTIVITY_OVERWRITTEN_SUCCESS,
    payload: newStatus,
  }
}
export const clearInviteSuccess = () => ({
  type: CLEAR_RESEND_SUCCESS,
})

export function setErrorMemberPage(code = '', extra = null) {
  return {
    type: SET_ERROR,
    payload: { UserFriendlyErrorCode: code, extra },
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setMember = (member) => ({
  type: SET_MEMBER,
  payload: member,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setEditedMemberData = (id, data) => ({
  type: SET_EDITED_MEMBER_DATA,
  payload: { id, data },
})
